export const getElement = selector => document.querySelector(selector);

export const elementExists = selector => null !== getElement(selector);

export const getAttribute = (selector, attribute, _default = false) => {
  let element = getElement(selector);
  let isData = /^data-/.test(attribute);

  if (null === element) {
    return _default;
  }

  let value = element.getAttribute(attribute);

  if (isData) {
    let json = element.dataset[attribute.replace(/^data-/, '')];

    try {
      value = JSON.parse(json);
    } catch (e) {
      value = json;
    }
  }

  if (value) {
    return value;
  }

  return _default;
};

export const setAttribute = (selector, attribute, value) => {
  let element = getElement(selector);

  if (null === element) {
    return false;
  }

  element.setAttribute(attribute, value);

  return true;
};

export const removeAllVuePreloadHiddenClasses = () => {
  const className = 'vue-preload-hidden';
  const elements = document.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].classList.remove(className);
  }
};
